"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFirstRender = void 0;
const react_1 = require("react");
/**
 * Run the provided function synchronously during the first render only.
 */
const useFirstRender = (fn) => {
    const isFirstRender = (0, react_1.useRef)(true);
    if (isFirstRender.current) {
        isFirstRender.current = false;
        fn();
    }
};
exports.useFirstRender = useFirstRender;
//# sourceMappingURL=useFirstRender.js.map